require("./plans")
require("./progress")
require("./fields")
// require("./conversations/subscriptions")
require("./availability")
require("./lessons")
require("./schedule")
require("./reschedule")
require("./schedule_lesson")
require("./calendar")
require("./students")
require("./tutors")
require("./video-upload")
require("./chat")
require("./chat_form")
require("./chat/speak_page_service")
require("./voice_version_toggle")
require('./bookings/booking_confirmation')
require('./subscriptions/user_subscription_confirmation')
require('./subscriptions/user_subscription_cancellation')
require('./chat_feedback/chat_feedback')
require('./vocabulary/flashcards_import_confirmation')
require('./onboarding_revamped')
// LAN-671: exposes window.LanguaVideoWatch for the explainer video partial.
require('./video_watch_analytics')
// LAN-1321: exposes window.LanguaPaddleCheckout for the free-trial checkout.
require('./paddle_checkout_analytics')
require('./lesson_progress')
require('./call_playground_benchmark')
require('./call_playground_waveform')
require('./call_playground_prompt_panel')
